module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_10-02b41d006765abec6ae45ad05ea19ab6.png";